import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex w-100 weather-report" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex w-100"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column justify-content-between w-15 me-2\"><div class=\"d-flex justify-content-between w-100\"><span class=\"shimmer-loading w-30 p-2\"></span><span class=\"shimmer-loading w-30 p-2\"></span></div><span class=\"shimmer-loading w-100 mt-1\"></span></div><div class=\"d-flex flex-column justify-content-between w-5\"><span class=\"shimmer-loading w-100 p-1\"></span><span class=\"shimmer-loading w-100 p-1\"></span></div>", 2)
const _hoisted_5 = {
  key: 1,
  class: "d-flex w-100 justify-content-center"
}
const _hoisted_6 = { class: "d-flex flex-column justify-content-around mt-n1" }
const _hoisted_7 = { class: "d-flex align-items-center justify-content-center fw-bold" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Today: ")
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-column weather-forecast",
  ref: "weatherForecastRef"
}
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "font-size-base" }
const _hoisted_13 = { class: "font-size-2xs degree" }
const _hoisted_14 = { class: "font-size-2xs degree" }
const _hoisted_15 = { class: "d-flex justify-content-end pe-2 py-2 white-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode(" LOADING "),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createCommentVNode(" ! not here "),
          _hoisted_3
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" DATA "),
    (_ctx.currentData && _ctx.forecastData && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("i", {
            class: _normalizeClass(["me-2 wi font-size-3xl", _ctx.getClassOfCurrentWeather])
          }, null, 2 /* CLASS */),
          _createCommentVNode(" CURRENT WEATHER "),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.locationData.city) + ", " + _toDisplayString(_ctx.locationData.state), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", {
                class: _normalizeClass(`${_ctx.isCelsius ? 'celsius' : 'degree'} ps-2`)
              }, _toDisplayString(_ctx.temperature), 3 /* TEXT, CLASS */)
            ])
          ]),
          _createElementVNode("i", {
            class: "fas fa-caret-down ms-2 font-size-xs cursor-pointer d-flex align-items-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleWeatherForecast())),
            ref: "toggleIconRef"
          }, null, 512 /* NEED_PATCH */),
          _createCommentVNode(" FORECAST  "),
          (_ctx.showWeatherForecast)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastData, (data, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `temp-${index}`,
                      class: "me-3 flex-column align-items-center d-flex"
                    }, [
                      _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.formatingDateOrTime(data.date, _ctx.durationDateFormat)), 1 /* TEXT */),
                      _createElementVNode("i", {
                        class: _normalizeClass(["wi font-size-lg my-1", _ctx.weatherClass(data.id)])
                      }, null, 2 /* CLASS */),
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(data.hi), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_14, " / " + _toDisplayString(data.lo), 1 /* TEXT */)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "btn btn-sm text-end",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSettings()))
                  }, "Edit")
                ])
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}